import { Component, Input } from '@angular/core'
import { AbstractControl } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'mmx-form-error',
  templateUrl: './form-error.component.html',
  standalone: false,
})
export class FormErrorComponent {
  @Input()
  public control: AbstractControl<any, any>

  constructor(
    private translateService: TranslateService,
  ) {}

  getErrorMessage() {
    if (this.control) {
      if (this.control.hasError('required')) {
        return this.translateService.instant('forms.errors.required')
      } else if (this.control.hasError('minlength')) {
        return this.translateService.instant('forms.errors.min-length', { value: this.control.errors?.minlength.requiredLength })
      } else if (this.control.hasError('maxlength')) {
        return this.translateService.instant('forms.errors.max-length', { value: this.control.errors?.maxlength.requiredLength })
      } else if (this.control.hasError('dateRangeInvalid')) {
        return this.translateService.instant('forms.errors.date-range-invalid')
      } else if (this.control.hasError('oneOf')) {
        return this.translateService.instant('forms.errors.one-of')
      }
    }
  }
}
